import * as Utils from './utils';

const list = document.querySelector('.js-timeline'),
    theresMore = document.querySelector('.js-timeline-theres-more'),
    loadMore = document.querySelector('.js-timeline-load-more');

if (list && window.fetch) {
    // Check if we've got all our results already
    if (gotAllResults()) {
        hideLoadMore();
    } else {
        showLoadMore();
    }

    // Clicking on load more
    loadMore.addEventListener('click', e => {
        e.preventDefault();

        var currentLength = document.querySelectorAll('.js-timeline-item').length;

        getMore(currentLength);
    });
}

function getMore(offset) {
    if (typeof offset === 'undefined') {
        offset = 0;
    }

    const formData = new FormData();
    formData.append('offset', offset);

    // Run AJAX request for more entries
    fetch('/about/_timeline-items', {
        method: 'POST',
        headers: { 
            "X-Requested-With": "XMLHttpRequest" 
        },
        body: formData
    })
        .then(response => response.text())
        .then(data => {
            // Append items to list
            let newItemsHTML = Utils.stringToHTML(data);
                    
            // Loop over returned list items and insert to DOM
            newItemsHTML.querySelectorAll('li').forEach(item => {
                list.appendChild(item);
            })

            // Run Picturefill
            if (typeof window.picturefill !== "undefined") {
                picturefill();
            }

            // Re-add the list to the imageFading array so that
            // the new descendants are faded
            Utils.animateInViewEls('.fading-el', 'in-view', 0.075);

            if (gotAllResults()) {
                hideLoadMore();
            } else {
                showLoadMore();
            }
        });
}

function gotAllResults() {
    // Get the children of the updated list
    var items = document.querySelectorAll('.js-timeline-item');

    // If we haven't got any items at all (no entries set),
    // or the length of the children is equal to the total results, return true
    return !items.length || items.length === items[0].dataset.totalresults;
}

function showLoadMore() {
    loadMore.classList.add('visible');

    theresMore.classList.add('visible');
}

function hideLoadMore() {
    loadMore.style.display = 'none';

    theresMore.style.display = 'none';

    document.querySelectorAll('.js-timeline-item:last-child').classList.add('last-item');
}